/**
 * ProtectedRoute - Componente para proteger rutas y aplicar AdminLayout
 */

import React from "react";
import { Route, Redirect } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { isStoredTokenValid } from "../../utils/adminAuth";

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const isAuthenticated = () => isStoredTokenValid();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          return <Redirect to="/" />;
        }

        // Si se pasa render como función, usarla
        if (render) {
          return (
            <AdminLayout>
              {render(props)}
            </AdminLayout>
          );
        }

        // Si se pasa component, usarlo
        if (Component) {
          return (
            <AdminLayout>
              <Component {...props} />
            </AdminLayout>
          );
        }

        return null;
      }}
    />
  );
};

export default ProtectedRoute;

